import { ErrorBoundary, Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { FlatList, Center } from 'native-base';
import React from 'react';

import { useRedeemOffersContext } from '../../../../contexts/redeem-offers';
import { Header } from '../Header';
import { Item } from '../Item';
import { Loading, LoadingRow } from '../Loading';
import { Separator } from '../Separator';

export const SentTable: React.FC = () => {
  const {
    isLoadingMoreRedeemOffers,
    isLoadingRedeemOffers,
    onLoadingMoreRedeemOffers,
    redeemOffersData,
    redeemOffersIsError,
    redeemOffersRefresher,
  } = useRedeemOffersContext();

  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <VStack px={{ base: 0, sm: Spacing['inline.xxs'] }}>
      {isDesktop && <Header />}
      <Shadow level={2} borderTopRadius={BoxRadius.sm}>
        {isLoadingRedeemOffers && <Loading />}
        {!redeemOffersIsError && !isLoadingRedeemOffers && redeemOffersData.length > 0 && (
          <FlatList
            data={redeemOffersData}
            ItemSeparatorComponent={Separator}
            h={{ base: 'lg', sm: 'sm', lg: 'lg' }}
            showsVerticalScrollIndicator={false}
            keyExtractor={(item) => item.id}
            renderItem={({ item }) => <Item data={item} />}
            onEndReachedThreshold={0.2}
            onEndReached={onLoadingMoreRedeemOffers}
            {...(isLoadingMoreRedeemOffers && { ListFooterComponent: LoadingRow })}
            ListFooterComponentStyle={{
              paddingVertical: Utils.Token.ToInt(Spacing, 'inline.quarck'),
            }}
          />
        )}
        {(redeemOffersIsError || redeemOffersData.length === 0) && !isLoadingRedeemOffers && (
          <Center h={{ base: 'lg', sm: 'sm', lg: 'lg' }}>
            <ErrorBoundary
              onRefresh={redeemOffersRefresher}
              errorIconOrIllustration="WarningIllustration"
              errorTitle="Houve um erro ao recuperar as informações da boleta."
              errorMessage="Não foi possível processar sua solicitação. Por favor, tente novamente mais tarde."
            />
          </Center>
        )}
      </Shadow>
    </VStack>
  );
};
